export default "__VITE_ASSET__DcE4xB_K__"